export interface ISmpBundle {
  smpBundleId: number;
  name: string;
  displayOrder:  number;  
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ISmpBundle = {
  getDefault(): ISmpBundle {
    return {
      smpBundleId: 0,
      name: '',
      displayOrder:  0,
    };
  },
};